import { render, staticRenderFns } from "./FourPup.vue?vue&type=template&id=0436d6a1&scoped=true"
import script from "./FourPup.vue?vue&type=script&lang=js"
export * from "./FourPup.vue?vue&type=script&lang=js"
import style0 from "./FourPup.vue?vue&type=style&index=0&id=0436d6a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0436d6a1",
  null
  
)

export default component.exports